import styles from './FormLayout.module.css';
import { Button, Icon } from '../../../../components';
import { useStorageStore } from '../../../../store/useStorageStore';
import { Icons } from '../../../../components/Icon/Icon';

const FormLayout = ({
    title,
    description,
    children,
    onClose,
    isAbsolute = false,
    footerMain,
    footerAdditional,
    footerAdditionalGrid,
    handleClose,
    handlePrevStep,
    useMargin = true,
    useSeparatorMargin = true,
    useContentPadding = true,
    minSize = 'sm',
}: any) => {
    const [setIsSmallStructure, activeStorageType, setOpenType] = useStorageStore((state) => [
        state.setIsSmallStructure,
        state.openType,
        state.setOpenType,
    ]);

    // const handleClose = () => {
    //     onClose ? onClose() : setOpenType(undefined);
    // };

    return (
        <div className={`${styles.form} ${isAbsolute ? styles.absolute : ''} ${styles[minSize]}`}>
            <div className={styles.formContent}>
                <header
                    className={`${styles.header} ${useMargin ? styles.margin : ''}  ${useSeparatorMargin ? styles.separatorMargin : ''}`}
                >
                    {!!title && (
                        <div className={styles.headerRow}>
                            <h1>{title}</h1>

                            <Button
                                onClick={handleClose || onClose}
                                color={'neutral'}
                                size={'md'}
                                after={<Icon icon={Icons.closeRounded} />}
                                responsiveIcon={true}
                            >
                                Close
                            </Button>
                        </div>
                    )}
                    {!!description && <h2>{description}</h2>}
                </header>

                {/*<hr className={`${styles.separator} ${useSeparatorMargin ? styles.separatorMargin : ''}`} />*/}

                <div className={`${styles.mainContent} ${useContentPadding ? styles.mainContentPadding : ''}`}>
                    {children}
                </div>

                {!!footerAdditional && (
                    <div className={`${styles.footerAdditional}`}>
                        <div
                            className={`${styles.footerAdditionalInner} ${footerAdditionalGrid ? styles.footerAdditionalGrid : ''}`}
                        >
                            {footerAdditional}
                        </div>
                    </div>
                )}

                {(!!handlePrevStep || !!footerMain) && (
                    <footer className={styles.footer}>
                        {!!handlePrevStep ? (
                            <Button color={'neutral'} size={'md'} onClick={handlePrevStep}>
                                Back
                            </Button>
                        ) : (
                            <span />
                        )}
                        {footerMain}
                    </footer>
                )}
            </div>
        </div>
    );
};

export default FormLayout;
